import React, { useContext, useEffect, useRef, useState } from 'react';
import { Grid, Header, Icon, Dropdown, Popup, List, Table as SemanticTable, Ref } from 'semantic-ui-react';

import { Contact, EllipsisDropdownPortal, LinkedAccount, Table } from 'dyl-components';
import { connect, useDispatch, useSelector } from 'react-redux';
import masterAccountActions from 'actions/master_account';
import { Link, useParams } from 'react-router-dom';
import LinkAccountDropdown from 'shared/LinkAccountDropdown';
import { StatusDropdown } from 'pages/Accounts/subcomponents/ConversionControls';
import  { FormsContext } from 'pages/Accounts/subcomponents/FormsProvider';
import Forms from 'pages/Accounts/subcomponents/Forms';
import { PhoneUtil } from 'utils';
import { ActivityPopup } from 'shared/forms/NewActivity';
import TextIcon from 'shared/TextIcon';
import { NotesModal, TextMessageModal } from 'shared/modals';
import SendEmailModal from 'shared/modals/SendEmailModal';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';


const DropdownItem = ({ text, icon, ...otherProps }) => {
    return (
        <Dropdown.Item text={<React.Fragment>
            <Icon name={icon} />
            {text}
        </React.Fragment>}
            style={{ cursor: 'pointer' }}
            {...otherProps}
        />
    );
}

const mapDispatchToProps = dispatch => ({
    readAccountsForPinning: (master_account_id, queryParameters) => {
        dispatch(masterAccountActions.readAccountsForPinning(master_account_id, queryParameters));
    }
})

const mapStateToProps = state => ({
    accountsForPinning: state.master_account.accountsForPinning.map(account => ({
        key: account.id,
        value: account.id,
        text: account.name,
        content: (
            <LinkedAccount account={account.name} subtitle={`ID: ${account.id}`} />
        )
    })),
    isReadingAccountsForPinning: state.master_account.isReadingAccountsForPinning,
});

const PinnedAccountRow = ({
    accounts,
    accountsForPinning,
    onUnpin,
    onReplacePinnedAccount,

    isReadingAccountsForPinning,
    pinnedAccount,
    master_account_id
}) => {
    const dispatch = useDispatch();
    const { onStatusDropdownSelect, onLinkSelect, onUnlinkSelect } = useContext(FormsContext)
    const actionPopupRef = React.createRef();
    const userPhoneCreds = useSelector(state => state?.officeView?.creds)
    const hasEmailIntegrations = useSelector(state => state.oauth_integrations.integrations?.length > 0);
    const [openForm, setOpenForm] = useState(false);
    const onOpenForm = (type) => {
        setOpenForm(type);
    }
    const onCloseForm = () => {
        setOpenForm('');
    }
    const isPhoneSystemSupported =
                    PhoneUtil.isPhoneSystemSupported(userPhoneCreds);
    const ref = useRef();
    const ELLIPSIS_OPTIONS = [
        {
            id: 1,
            text: 'Change Master Account',
            icon: 'fa-solid fa-buildings',
            onClick: (e, id, master_id)=>{
                onLinkSelect(id,master_id);
            },
            userPermission: USER_PERMISSIONS.MASTER_ACCOUNT_EDIT
        },
        {
            id:2,
            text: 'Unlink Master Account',
            icon: 'fas fa-diagram-nested',
            onClick: (e, id, master_id)=>{
                onUnlinkSelect(actionPopupRef, { account_id: id , master_account: master_id});
            },
            userPermission: USER_PERMISSIONS.MASTER_ACCOUNT_EDIT
        }
    ];

    const isPinned = (account_id) => {
        return (accounts.findIndex(account => account.id === account_id) !== -1)
    }

    const { counts , primary_contact, id, name, customer } = pinnedAccount;

    const onClickToDial = () => {
        const destination = primary_contact?.primary_phone?.phone;
        const contact_id = primary_contact?.id;
        PhoneUtil.C2D({ payload: { account_id: id, contact_id, destination }, dispatch })
    }
    return (
        <Table.Row key={id}>
            <Table.Cell>
                <Popup
                    trigger={
                        <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.MASTER_ACCOUNT_EDIT}>
                            <Icon onClick={() => { onUnpin(pinnedAccount.id); }} color='primary' link className='fas thumbtack' />
                        </RestrictedView>
                    }
                    content='Unpin'
                    inverted
                />
            </Table.Cell>
            <Table.Cell>
                <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.MASTER_ACCOUNT_EDIT}>
                    <Dropdown
                        placeholder='Pin an Account'
                        selectOnBlur={false}
                        selection
                        options={accountsForPinning.filter(({ value }) => !isPinned(value))}
                        value={id}
                        onChange={(_, { value: account_id }) => {
                            if (account_id) {
                                if (account_id !== id) {
                                    onReplacePinnedAccount(id, account_id);
                                }
                            } else {
                                onUnpin(id);
                            }
                        }}
                        compact
                        text={(
                            <LinkedAccount
                                account={name}
                                maxWidth={'8.25em'}
                                subtitle={id && `ID: ${id}`}
                                popup
                                linkToAccount={
                                    <RestrictedView userPermission={USER_PERMISSIONS.ACCOUNT_VIEW} type="link" assignmentIds={[(pinnedAccount?.owner_id || 0), (pinnedAccount?.coowner_id || 0)]} userRestrict> 
                                        <Link onClick={e => {e.stopPropagation();}} target={"_blank"} to={`/account/${id}`}>{name}</Link>
                                    </RestrictedView>
                                }
                            />
                        )}
                        clearable
                        loading={isReadingAccountsForPinning}
                        style={{ width: '15em' }}
                    />
                </RestrictedView>
            </Table.Cell>
            <Table.Cell>
                {primary_contact?.id && (
                    <>
                        <Contact
                            leftSideContent={
                                <div className='Contact_LeftsideContent'>

                                    <Icon color={primary_contact?.id ? 'primary' : 'grey'} className='fas fa-address-book' />
                                    <LinkedAccount
                                        maxWidth={'8.25em'}
                                        account={`${primary_contact.first_name} ${primary_contact.last_name}`}
                                        subtitle={primary_contact.primary_email?.email}
                                        linkToAccount={
                                            <RestrictedView userPermission={USER_PERMISSIONS.CONTACTS_VIEW} type="link" assignmentIds={[(pinnedAccount?.primary_contact?.owner_id || 0), (pinnedAccount?.primary_contact?.coowner_id || 0)]} userRestrict>
                                                <Link target={'_blank'} to={`/contact/${primary_contact.id}`}>{primary_contact.first_name} {primary_contact.last_name}</Link>
                                            </RestrictedView>
                                        }
                                    />

                                </div>
                            }
                            isFixedWidth={false}
                            phone={primary_contact.primary_phone?.phone}
                            email={primary_contact.primary_email?.email}
                            account_id={id}
                            contact_id={primary_contact?.id}
                            isPhoneSystemSupported={isPhoneSystemSupported}
                            hasEmailIntegrations={hasEmailIntegrations}
                            onCallClick={onClickToDial}
                            onTextClick={() => onOpenForm('text-modal')}
                            onEmailClick={() => onOpenForm('email-modal')}
                            onNoteClick={() => onOpenForm('note')}
                            ActivityPopup={ActivityPopup}
                            TextIcon={TextIcon}
                            callActivityProps={{
                                hideActivitySelection: true,
                                contact: { id },
                                isContact: true
                            }}
                            emailActivityProps={{
                                emailOnly: true,
                                contact: {
                                    ...primary_contact,
                                    email: primary_contact.primary_email?.email
                                }
                            }}
                            callSuspended={primary_contact.primary_phone?.call_suspended}
                        />
                        <NotesModal
                            open={openForm === "note"}
                            onClose={() => { onCloseForm() }}
                            contact={primary_contact}
                        />
                        <TextMessageModal
                            open={openForm === "text-modal"}
                            onClose={onCloseForm}
                            contact_name={`${primary_contact.first_name} ${primary_contact.last_name}`}
                            contact_id={primary_contact?.id}
                        />
                        <SendEmailModal
                            open={openForm === "email-modal"}
                            onClose={onCloseForm}
                            contact_id={primary_contact?.id}
                            emailInfo={primary_contact?.primary_email}
                        />
                    </>
                )}
            </Table.Cell>
            <Table.Cell>
                <List>
                    <List.Item>
                        <Link to={`/account/${id}/contacts`} target="_blank">{counts?.contact_count || 0} contact{counts?.contact_count > 1 && 's'}</Link>
                    </List.Item>
                    <List.Item>
                        <Link to={`/account/${id}/leads?filter=open`} target="_blank">{counts?.lead_count || 0} lead{counts?.lead_count > 1 && 's'}</Link>
                    </List.Item>
                    <List.Item>
                        <Link to={`/account/${id}/opportunities?filter=open`} target="_blank">{counts?.opportunity_count || 0} {counts?.opportunity_count > 1 ? 'opportunities' : 'opportunity'}</Link>
                    </List.Item>
                </List>
            </Table.Cell>
            <Table.Cell>
                {customer?.customer_fund_type !== "unfunded" && <StatusDropdown
                    account={{ ...pinnedAccount, account_status: customer?.customer_status }}
                    onStatusDropdownSelect={onStatusDropdownSelect}
                />}
            </Table.Cell>
            <Table.Cell>
                <Ref innerRef={ref}>
                    <EllipsisDropdownPortal reference={ref}>
                        {ELLIPSIS_OPTIONS.map(({ text, icon, userPermission, ...otherProps }, idx) => {
                            return (
                                <Ref innerRef={actionPopupRef}>
                                    <RestrictedView type="disabled" userPermission={userPermission}>
                                        <DropdownItem
                                            key={idx}
                                            text={text}
                                            icon={icon}
                                            {...otherProps}
                                            onClick={
                                                (e) => {
                                                    otherProps.onClick(e, pinnedAccount.id.toString(), master_account_id);
                                                }
                                            }
                                        />
                                    </RestrictedView>
                                </Ref>
                            );
                        })}
                    </EllipsisDropdownPortal>
                </Ref>
            </Table.Cell>
        </Table.Row>
    );
}

export const PinnedAccounts = connect(mapStateToProps, mapDispatchToProps)(({
    accounts,
    accountsForPinning,

    onPin,
    onUnpin,
    onReplacePinnedAccount,
    refresh,

    isReadingAccountsForPinning,
    readAccountsForPinning,
}) => {
    const { master_account_id } = useParams();

    useEffect(() => {
        readAccountsForPinning(master_account_id, { page: 1, limit: 100 });
    }, [master_account_id, readAccountsForPinning]);

    const rows = [
        ...accounts.map(pinnedAccount => (
            <PinnedAccountRow
                accounts={accounts}
                accountsForPinning={accountsForPinning}
                isReadingAccountsForPinning={isReadingAccountsForPinning}
                master_account_id={master_account_id}
                key={pinnedAccount.id}
                pinnedAccount={pinnedAccount}
                onReplacePinnedAccount={onReplacePinnedAccount}
                onUnpin={onUnpin}
                refresh={refresh} />
        ))
    ];

    while (rows.length < 3) {
        rows.push((
            <Table.Row>
                <Table.Cell>
                    <Icon color='grey' className='fas thumbtack' />
                </Table.Cell>
                <Table.Cell>
                    <RestrictedView type="disabled" userPermission={USER_PERMISSIONS.MASTER_ACCOUNT_ADD}>
                        <Dropdown
                            placeholder='Pin an Account'
                            selectOnBlur={false}
                            selection
                            options={accountsForPinning.filter(({ value }) => (accounts.findIndex(account => account.id === value) === -1))}
                            onChange={(_, { value: account_id }) => { onPin(account_id) }}
                            compact
                            style={{ width: '15em' }}
                            value={null}
                            loading={isReadingAccountsForPinning}
                        />
                    </RestrictedView>
                </Table.Cell>
                <Table.Cell></Table.Cell>
                <Table.Cell></Table.Cell>
                <Table.Cell></Table.Cell>
                <Table.Cell></Table.Cell>
            </Table.Row>
        ))
    }

    return (
        <React.Fragment>
            <Forms readAccounts={refresh} />
            <Header as='h4' color='blue'>
                <LinkAccountDropdown
                    triggerProps={{
                        trigger: <Icon size='large' className='fas fa-plus-circle' />,
                        icon: ''
                    }}
                /> Accounts
            </Header>
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <Table striped={false}>
                            <SemanticTable.Header className='Table__header--primary'>
                                <Table.Row>
                                    <SemanticTable.HeaderCell width={1} />
                                    <SemanticTable.HeaderCell>Account</SemanticTable.HeaderCell>
                                    <SemanticTable.HeaderCell>Primary Contact</SemanticTable.HeaderCell>
                                    <SemanticTable.HeaderCell>Modules</SemanticTable.HeaderCell>
                                    <SemanticTable.HeaderCell>Account Status</SemanticTable.HeaderCell>
                                    <SemanticTable.HeaderCell>Actions</SemanticTable.HeaderCell>
                                </Table.Row>
                            </SemanticTable.Header>
                            <Table.Body>
                                {rows}
                            </Table.Body>
                        </Table>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </React.Fragment>
    );
});
